const a = {
  code: "tr",
  facebook: "tr_TR",
  label: "Türkçe",
  loadingText: "Yükleniyor...",
  translations: {
    ar: "Arapça",
    de: "Almanca",
    en: "İngilizce",
    es: "İspanyolca",
    fr: "Fransızca",
    he: "İbranice",
    hi: "Hintçe",
    id: "Endonezce",
    it: "İtalyanca",
    ja: "Japonca",
    km: "Kmerce",
    ko: "Korece",
    lo: "Laosça",
    ms: "Malayca",
    nl: "Hollandaca",
    pt: "Portekizce",
    ru: "Rusça",
    th: "Tayca",
    tl: "Filipince",
    tr: "Türkçe",
    vi: "Vietnamca",
    "zh-CN": "Çince (Basit)",
    "zh-TW": "Çince (Geleneksel)"
  }
};
export {
  a as turkish
};
